import Vue from "vue";
import App from "./App.vue";

//external dependencies
import Toasted from "vue-toasted";
import * as VueGoogleMaps from "vue2-google-maps";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "./styles.css";
import "./assets/css/responsive.css";
import "./assets/css/shortcode/shortcodes.css";
import BootstrapVue from "bootstrap-vue";
import InstantSearch from "vue-instantsearch";
import { rtdbPlugin } from "vuefire";
import { firestorePlugin } from "vuefire";
//modules
import constants from "./modules/constants";
import router from "./modules/router";
import store from "./modules/store";
import { getUser, logout } from "./modules/auth";

//populate font awesome icons
import "./modules/faIconLibrary";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

// use tamplates
import Default from "./layouts/Default.vue";
import Website from "./layouts/Website.vue";

Vue.component("default-layout", Default);
Vue.component("website-layout", Website);

//use modules
Vue.use(VueGoogleMaps, {
  load: {
    key: constants.api_keys.googlemaps,
    libraries: "places,drawing,geometry"
  }
});
import ReadMore from "vue-read-more";
Vue.use(ReadMore);
import AOS from "aos";
import "aos/dist/aos.css";
Vue.use(Toasted);
Vue.use(BootstrapVue);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.use(InstantSearch);
Vue.use(firestorePlugin);
Vue.use(rtdbPlugin);

//Progressive Web App support
import "./modules/registerServiceWorker";

// disable production tip in console
Vue.config.productionTip = false;

new Vue({
  router,
  store,

  mounted() {
    getUser();
  },

  methods: {
    logout() {
      logout().then(() => {
        // this.$store.dispatch("clearAuth"); ::already done in auth listener
        this.toast(constants.info.logged_out);
        router.push("/");
      });
    },
    toast(text) {
      this.$toasted.show(text, {
        theme: "primary",
        position: "top-center",
        duration: 3000
      });
    }
  },

  created() {
    AOS.init();
  },
  render: h => h(App)
}).$mount("#app");
